export const summaryRows: string[] = [
  'Volume 1 — Matter & Atomic Structure: From Particles to Electron Configuration',
  'Volume 2 — The Periodic Table & Chemical Bonding',
  'Volume 3 — Chemical Reactions, the Mole & Stoichiometry',
  'Volume 4 — Solutions, Acids & Bases, Rates & Equilibrium',
  'Volume 5 — Organic Chemistry: Carbon, Functional Groups & Polymers',
  'Volume 6 — School Laboratory Safety & Practical Chemistry',
  'Bonus 1 — Chemistry Practice Problem Bank with Answer Keys',
  'Bonus 2 — Periodic Table & Element Profile Cards',
  'Bonus 3 — Illustrated Chemistry Glossary & Vocabulary Cards',
  'Bonus 4 — Chemistry Quick-Reference Charts & Formula Sheets',
  'Bonus 5 — Landmark Discoveries in Chemistry: Timeline & Scientist Case Studies',
  '7-day money-back guarantee',
  'Instant access',
];
